import { helpers } from 'vuelidate/lib/validators'
import { detectedCulture } from 'utilities/common/culture'
import { get, find } from 'lodash'

const countryCode = detectedCulture.countryCode

export const zipCodeRegexs = [
  { code: 'NL', regex: /^\d{4}?\s[a-zA-Z]{2}$/ },
  { code: 'US', regex: /^\d{5}(-\d{4})?$/ },
  { code: 'CA', regex: /^[A-Za-z]\d[A-Za-z][\s]\d[A-Za-z]\d$/ },
  { code: 'DE', regex: /^\d{5}$/ },
  { code: 'PL', regex: /^\d{2}-\d{3}$/ },
  { code: 'GB', regex: /^[a-zA-Z]{1,2}[0-9][a-zA-Z0-9]?\s?[0-9][a-zA-Z]{2}$/ },
  { code: 'FR', regex: /^\d{5}$/ },
  { code: 'CZ', regex: /^\d{3}\s{1}\d{2}$/ },
  { code: 'ES', regex: /^(\d{5})$/ },
  { code: 'BE', regex: /^(\d{4})$/ },
  { code: 'IT', regex: /^(\d{5})$/ },
  { code: 'AT', regex: /^(\d{4})$/ },
  { code: 'FR', regex: /^(\d{5})$/ },
  { code: 'SE', regex: /^\d{3}\s{1}\d{2}$/ },
  { code: 'RO', regex: /^(\d{6})$/ },
]

export const houseNumberRegexs = [
  { code: 'NL', regex: /^(?=.*\d)[\da-zA-Z/]{1,4}$/ },
  { code: 'US', regex: /^(?=.*\d)[\da-zA-Z/]{1,4}$/ },
  { code: 'CA', regex: /^(?=.*\d)[\da-zA-Z/]{1,4}$/ },
  { code: 'DE', regex: /^(?=.*\d)[\da-zA-Z/]{1,4}$/ },
  { code: 'PL', regex: /^(?=.*\d)[\da-zA-Z/]{1,10}$/ },
  { code: 'GB', regex: /^(?=.*\d)[\da-zA-Z/]{1,4}$/ },
  { code: 'ES', regex: /^(\d{1,4})$/ },
  { code: 'BE', regex: /^(?=.*[a-zA-Z0-9])(?=.*[0-9])[a-zA-Z0-9\\s/-]{1,5}$/ },
  { code: 'IT', regex: /^(\d{1,4})$/ },
  { code: 'AT', regex: /^(?=.*[a-zA-Z0-9])(?=.*[0-9])[a-zA-Z0-9\\s/-]{1,5}$/ },
  { code: 'FR', regex: /^(\d{1,5})$/ },
  { code: 'SE', regex: /^(\d{1,5})$/ },
  { code: 'RO', regex: /^(\d{1,5})$/ },
  { code: 'CZ', regex: /^(?=.*\d)[\da-zA-Z/]{1,10}$/ }
]

const phoneNumberRegexs = [
  { code: 'NL', regex: /^([+]31|0)-?6[\s|-]?(\d[\s|-]?){8}$/ },
  { code: 'US', regex: /^((0{1,2}|\+)1[\s|-]?)?[2-9][\s|-]?(\d[\s|-]?){2}[2-9](?!11)[\s|-]?(\d[\s|-]?){5}\d$/ },
  { code: 'CA', regex: /^((0{1,2}|\+)1[\s|-]?)?[2-9][\s|-]?(\d[\s|-]?){2}[2-9](?!11)[\s|-]?(\d[\s|-]?){5}\d$/ },
  { code: 'DE', regex: /^([+][0-9]{1,3}[ .-])?([(]{1}[0-9]{1,6}[)])?([0-9 .\-/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/ },
  { code: 'PL', regex: /^(\D*\d\D*){7,13}$/ },
  { code: 'GB', regex: /^(\d\s*){0,11}$/ },
  { code: 'FR', regex: /^[\d()+-]{1,20}$/ },
  { code: 'SE', regex: /^[\d()+-]{1,20}$/ },
  { code: 'ES', regex: /^[\d()+-]{1,20}$/ },
  { code: 'BE', regex: /^[\d()+-]{1,20}$/ },
  { code: 'IT', regex: /^[\d()+-]{1,11}$/ },
  { code: 'AT', regex: /^[\d()+-]{1,20}$/ },
  { code: 'RO', regex: /^[\d()+-]{1,20}$/ },
  { code: 'CZ', regex: /^[\d()+-]{1,20}$/ }
]

const nameRegexs = [
  { code: 'NL', regex: /^[\u00c0-\u017ea-zA-Z]([\s\u00c0-\u017ea-zA-Z'-])*$/ },
  { code: 'US', regex: /^[a-zA-Z]([\sa-zA-Z'-])*$/ },
  { code: 'GB', regex: /^[a-zA-Z]([\sa-zA-Z'-])*$/ },
  { code: 'ES', regex: /^[^<>)(*^%$=`:;~,./{}@[\]?!\\"&+^#|]{1,20}$/ },
  { code: 'BE', regex: /^[^<>)(*^%$=`:;~,./{}@[\]?!\\"&+^#|]{1,20}$/ },
  { code: 'IT', regex: /^[^<>)(*^%$=`:;~,./{}@[\]?!\\"&+^#|]{1,20}$/ },
  { code: 'AT', regex: /^[^<>)(*^%$=`:;~,./{}@[\]?!\\"&+^#|]{1,20}$/ },
  { code: 'FR', regex: /^[^<>)(*^%$=`:;~,./{}@[\]?!\\"&+^#|]{1,20}$/ },
  { code: 'SE', regex: /^[^<>)(*^%$=`:;~,./{}@[\]?!\\"&+^#|]{1,20}$/ },
  { code: 'RO', regex: /^[^<>)(*^%$=`:;~,./{}@[\]?!\\"&+^#|]{1,20}$/ },
  { code: 'CZ', regex: /^[^<>)(*^%$=`:;~,./{}@[\]?!\\"&+^#|]{1,20}$/ },
]

export const phoneNumberRegex = get(find(phoneNumberRegexs, { 'code': countryCode }), 'regex', find(phoneNumberRegexs, { 'code': 'NL' })['regex'])

const nameRegex = get(find(nameRegexs, { 'code': countryCode }), 'regex', find(nameRegexs, { 'code': 'NL' })['regex'])
export const name = helpers.regex('name', nameRegex)

export const password = helpers.regex('password', /(^(?!^(\d+|[a-zA-Z]+|[~!_.@$]+)$)^[\w~!_.@$]{8,20}$)/)

export const includeNumberRegex = new RegExp(/\d+/)

export const addressRegex = new RegExp(/^(.*\s+)?((((post(al)?\s+)|(p[.\s]*))((((office\s)|(o[.\s]+))(b(in|ox)))).*)|(postal\s+((b(in|ox))))|(fedex)).*$/, 'i')
